"use client";

import BFLLink from "@repo/shared-ui/BFLLink";
import { handleHeaderCartClickDL } from "./HeaderAnalyticsFunction";

interface HeadercartProps {
  headercart?: {
    ctaInNewTab: string;
    ctaLink: string;
    defaultCount: string;
    heading: string;
    maxCount: string;
    showOnApp: string;
    showOnWeb: string;
  };
}

const Cart: React.FC<HeadercartProps> = ({ headercart }) => {
  const cartUrl = "/webform/v1/mycart?v1=/webform/v1/mycart&sso-module=cart";

  return (
    <BFLLink
      href={cartUrl}
      onClick={() => handleHeaderCartClickDL(cartUrl)}
      className="order-2 mx-0 my-0 flex flex-col items-center px-2 pb-[30px] pt-[17px] hover:bg-[#001326] md:order-4"
    >
      <i
        className="icomoon text-2xl before:content-['\e95f']"
        data-testid="cart-icon"
      ></i>
      <span
        className="hidden text-xs leading-[14px] md:!block"
        data-testid="cart-heading"
      >
        {headercart?.heading}
      </span>
    </BFLLink>
  );
};
export default Cart;
